/** Row shape from special-fee pickers / API mapping (Signage add + work order). */
export type SpecialFeeBreakdownRow = {
  id?: string;
  name?: string;
  specialfee_name?: string;
  amount?: number;
  specialfee_amount?: number;
};

function pickFeeName(f: SpecialFeeBreakdownRow): string {
  const n = String(f?.name ?? f?.specialfee_name ?? "").trim();
  return n || "Special Fee";
}

function pickFeeAmount(f: SpecialFeeBreakdownRow): number {
  const a = Number(f?.amount ?? f?.specialfee_amount ?? 0);
  return Number.isFinite(a) ? a : 0;
}

function shortenEnd(s: string, maxLen: number): string {
  const t = s.trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, Math.max(0, maxLen - 3))}...`;
}

/**
 * Left-column label + tooltip for installation Cost Breakdown "Special Fee" line.
 * - One fee: `Special Fee (Short name…)`
 * - Several: `Special Fee (First short…) +N` where N = number of additional fees (outside the parens).
 */
export function buildSpecialFeeCostBreakdownDisplay(
  fees: SpecialFeeBreakdownRow[] | null | undefined,
  options?: { maxNameLen?: number }
): { labelText: string; tooltip: string | undefined } {
  const maxNameLen = options?.maxNameLen ?? 32;
  const arr = Array.isArray(fees) ? fees.filter((f): f is SpecialFeeBreakdownRow => Boolean(f)) : [];
  if (arr.length === 0) {
    return { labelText: "Special Fee", tooltip: undefined };
  }
  const tooltip = arr.map((f) => `${pickFeeName(f)} — $${pickFeeAmount(f).toFixed(2)}`).join("\n");
  if (arr.length === 1) {
    return { labelText: `Special Fee (${shortenEnd(pickFeeName(arr[0]), maxNameLen)})`, tooltip };
  }
  const first = shortenEnd(pickFeeName(arr[0]), maxNameLen);
  return { labelText: `Special Fee (${first}) +${arr.length - 1}`, tooltip };
}
